import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import ExtensionSyncListener from './components/ExtensionSyncListener'
import LoginPage from './pages/LoginPage'
import CartsPage from './pages/CartsPage'
import CartDetailPage from './pages/CartDetailPage'
import LibraryPage from './pages/LibraryPage'
import SearchPage from './pages/SearchPage'
import CompareCartsPage from './pages/CompareCartsPage'
import SharedCartPage from './pages/SharedCartPage'
import PriceHistoryGallery from './pages/PriceHistoryGallery'
import BudgetOptimizationGallery from './pages/BudgetOptimizationGallery'
import CartInterfacesGallery from './pages/CartInterfacesGallery'
import AdminUiGallery from './pages/AdminUiGallery'
import AdminPage from './pages/AdminPage'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { useActivityHeartbeat } from './hooks/useActivityHeartbeat'
import { ThemeProvider, useTheme } from './contexts/ThemeContext'
import { BackgroundProvider } from './contexts/BackgroundContext'
import { LanguageProvider } from './contexts/LanguageContext'
import { NotificationProvider } from './contexts/NotificationContext'
import NotificationContainer from './components/NotificationContainer'
import BackgroundLoader from './components/BackgroundLoader'
import './App.css'

function AppContent() {
  const { user, loading } = useAuth()
  useActivityHeartbeat(Boolean(user))

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Chargement...</div>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/carts" />} />
        <Route path="/carts" element={user ? <CartsPage /> : <Navigate to="/login" />} />
        <Route path="/carts/:cartId" element={user ? <CartDetailPage /> : <Navigate to="/login" />} />
        <Route path="/library" element={user ? <LibraryPage /> : <Navigate to="/login" />} />
        <Route path="/search" element={user ? <SearchPage /> : <Navigate to="/login" />} />
        <Route path="/compare" element={user ? <CompareCartsPage /> : <Navigate to="/login" />} />
        <Route path="/admin" element={user ? <AdminPage /> : <Navigate to="/login" />} />
        <Route path="/shared/:token" element={<SharedCartPage />} /> {/* Route publique */}
        {import.meta.env.DEV ? (
          <>
            <Route path="/dev/price-history" element={<PriceHistoryGallery />} />
            <Route path="/dev/budget-optimization" element={<BudgetOptimizationGallery />} />
            <Route path="/dev/cart-interfaces" element={<CartInterfacesGallery />} />
            <Route path="/dev/admin-ui" element={<AdminUiGallery />} />
          </>
        ) : null}
        <Route path="/" element={<Navigate to={user ? "/carts" : "/login"} />} />
      </Routes>
    </BrowserRouter>
  )
}

function App() {
  return (
    <ThemeProvider>
      <ExtensionSyncListener />
      <BackgroundProvider>
        <LanguageProvider>
          <NotificationProvider>
            <AuthProvider>
              <BackgroundLoader />
              <div className="lg-blur-prewarm" aria-hidden="true" />
              <AppContent />
              <NotificationContainer />
            </AuthProvider>
          </NotificationProvider>
        </LanguageProvider>
      </BackgroundProvider>
    </ThemeProvider>
  )
}

export default App










